// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const stringifyKeys = (values: Record<string, string>) =>
  Object.keys(values).reduce((result, key) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    result[`key${key}`] = values[key];
    return result;
  }, {});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const destringifyKeys = (values: Record<string, string>) =>
  Object.keys(values).reduce((result, key) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    result[key.substring(3)] = values[key];
    return result;
  }, {});
